import { Attribute, Relationship, Resource } from 'json-api';
import { Translatable } from 'src/app/translation/translatable';
import { AtomResource } from '../classes/atom-resource';
import { Job } from './job.resource';
import { BillingChannel } from './billing-channel.resource';
import { NumberFilter, ResourceListFilter, StringFilter } from '../../filter/filter';
import { AtomService } from '../atom.service';
import { ResourceConfig } from '../../resources/resources-interfaces/resource-config';

import {
  BillingChannelConfig as SearchBillingChannelConfig,

} from 'src/app/shared/tools/search/search-config';
@Resource({
  type: 'activities',
})
export class Activity extends AtomResource {
  @Attribute() name?: Translatable;
  @Attribute() desc?: string;

  @Relationship() billingchannels?: BillingChannel[];

  get isMNO(): boolean {
    return this.id === '2';
  }

  get isISP(): boolean {
    return this.id === '3';
  }

  get isPayment(): boolean {
    return this.id === '4';
  }
}

export class ActivityConfig implements ResourceConfig {
  hosted ='billingchannels'
  tables = {
    includes: [
      'billingchannels'
    ],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        translatable: false,
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'name',
        displayedDatas: [
          {
            path: ['name'],
            class: 'mat-body-2',
          },
        ],
        header: 'Name',
        displayed: true,
        link: {
          detail: true,
        },
        sort: 'name',
      },
      {
        columnDef: 'desc',
        displayedDatas: [
          {
            path: ['desc'],
            class: 'mat-body-2',
          },
        ],
        header: 'Description',
        displayed: true,
        sort: 'desc',
      },
      {
        columnDef: 'billingchannels',
        displayed: true,
        link: {
          resource: 'billingchannels',
          list: 'billingchannels',
          target: 'activity',
        },
        header: 'Billing channels',
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'store',
      title: [
        {
          path: ['name'],
          translatable: true,
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: true,
        columns: true,
        list: [
          {
            icon: 'description',
            title: 'Description',
            value: {
              path: ['desc'],
              translatable: false,
            }
          },
        ]
      },
      {
        title:"Billing channels",
        list: [
          {
            type: "chips",
            APIKey: "billingchannels",
            value: {
              path: ["name"]
            }
          },
        ]
      },
    ],
  };
  wizard = {
    noCloseAfterCreation: false,
    tabs: [
      {
        title: 'Activity',
        formGroup: 'activity',
        list: [
          {
            type: 'text',
            title: 'Name',
            formControl: 'name',
            APIKey: 'name',
            required: true,
            translatable: true,
          },
          {
            type: 'text',
            title: 'Description',
            formControl: 'desc',
            APIKey: 'desc',
            required: false,
          },
        ],
      },
      {
        title: 'Billing Channels',
        formGroup: 'billingchannels',
        list: [
          {
            type: 'resource',
            title: 'Billing Channels',
            formControl: 'billingchannels',
            APIKey: 'billingchannels',
            search: new SearchBillingChannelConfig(true),
            noCols:true
          },
        ],
      },
    ],
  };
  resource = Activity;
  resourceName?: string | undefined = 'activities';
  resourceKey?: string | undefined = 'activities';
  resourceKeySingle?: string | undefined = 'activity';
  includes?: string[] | undefined = [
    'billingchannels',
  ];
  filters = [
    new NumberFilter('id', 'ID'),
    new StringFilter('name', 'Name',true),
    new StringFilter('desc','Description'),
    new ResourceListFilter(
      this.atom,
      BillingChannel,
      'billingchannels.id',
      'Billing channel'
    ),
  ];
  constructor(private atom: AtomService) {}

}
